import { ArrowRight, BriefcaseBusiness, Check, Megaphone, ShoppingBag, Users } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PageHero } from './shared'

export function SolutionsPage() {
  const solutions = [
    {
      title: 'A founder who is doing too much',
      copy: 'DAWN can prepare summaries, track recurring jobs and bring the few decisions that genuinely need the founder into one place.',
      icon: BriefcaseBusiness,
      bullets: ['A clear daily or weekly priority list', 'Warnings when jobs fail or fall behind', 'Drafts and research prepared before review'],
    },
    {
      title: 'A business struggling to market consistently',
      copy: 'DAWN can use approved business information to prepare content ideas, campaign plans, emails and product wording without inventing a new brand voice every time.',
      icon: Megaphone,
      bullets: ['Content and campaign plans', 'Email and social first drafts', 'Brand and claim checks before approval'],
    },
    {
      title: 'A shop with too many products and updates',
      copy: 'DAWN can help organise product information, spot missing details and prepare website or catalogue improvement lists.',
      icon: ShoppingBag,
      bullets: ['Product description preparation', 'Catalogue and link checks', 'Website improvement recommendations'],
    },
    {
      title: 'A sales team losing time on research and follow-up',
      copy: 'DAWN can prepare account information, meeting briefs and follow-up drafts so salespeople spend more time speaking to the right prospects.',
      icon: Users,
      bullets: ['Lead and company research', 'Meeting preparation', 'Follow-up drafts and next-step reminders'],
    },
  ] as const

  return (
    <>
      <PageHero
        title="What could DAWN help with?"
        copy="Start with a familiar business problem—not an AI project. Here are some examples of work DAWN can prepare, organise or keep track of."
      />
      <section className="section">
        <div className="container solution-list">
          {solutions.map(({ title, copy, icon: Icon, bullets }) => (
            <article key={title}>
              <div><Icon size={28} /><h2>{title}</h2><p>{copy}</p></div>
              <ul>{bullets.map(item => <li key={item}><Check size={16} />{item}</li>)}</ul>
              <Link to="/request-demo">Could this help me? <ArrowRight size={16} /></Link>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
